<div class="ap-recipients">
    <div class="ap-recipients-header">
        <p class="ap-section-label">
            {{ section.label }}
            <span class="ap-recipients-count">· {{ activeCount() }} units</span>
        </p>
    </div>

    <!-- V2 unit selector IS the recipient list. Existing units come back
         pre-checked; the user checks / unchecks to adjust the batch.
         Max-height capped so this never takes over the chat — internal
         scrolling handles bigger orgs. -->
    <div class="ap-recipients-picker" *ngIf="!isOverflowing">
        <app-v2-unit-selector
            [selectionMode]="true"
            [preselectedUnitIds]="existingUnitIds"
            [isDisplayedInModal]="false"
            [initialFilterPanelOpen]="false"
            (onSelect)="onSelectionChange($event)">
        </app-v2-unit-selector>
    </div>

    <ul class="ap-recipients-list" *ngIf="isOverflowing">
        <li
            *ngFor="let item of section.items; let last = last; trackBy: trackByItemId"
            class="ap-recipient-row"
            [class.is-last]="last"
            [class.is-removed]="isRemoved(item)">
            <div class="ap-recipient-text">
                <p class="ap-recipient-primary">{{ item.primary }}</p>
                <p class="ap-recipient-secondary" *ngIf="item.secondary">{{ item.secondary }}</p>
            </div>
            <button
                *ngIf="item.removable"
                type="button"
                class="ap-recipient-remove"
                [attr.aria-label]="(isRemoved(item) ? 'Restore ' : 'Remove ') + item.primary"
                (click)="toggleRemove(item)">
                <i class="ph-bold ph-x" aria-hidden="true"></i>
            </button>
        </li>
    </ul>

    <p class="ap-recipients-overflow" *ngIf="overflowCount > 0">
        +{{ overflowCount }} more not shown — list too large to edit individually
    </p>
</div>
